import { AvailabilityForm } from '../types';

export const getSelectedTimeslotsWithStaffAndRoomAllocation = (
  allGuestExperiences: { timeslots: (AvailabilityForm | undefined)[][] }[]
) => {
  const { selectedTimeslotsWithStaffAndRoomAllocation } = (allGuestExperiences || []).reduce(
    (
      acc: {
        allocatedStaffMap: Map<string, string[]>;
        allocatedRoomsMap: Map<string, string[]>;
        selectedTimeslotsWithStaffAndRoomAllocation: string[];
      },
      curr,
      guestIndex
    ) => {
      curr?.timeslots?.forEach((t, dayIndex) => {
        t?.forEach((ts) => {
          if (ts) {
            const {
              allocatedRoomsMap,
              allocatedStaffMap,
              selectedTimeslotsWithStaffAndRoomAllocation,
            } = acc;
            const unavailableStaffForTimeslot = allocatedStaffMap.get(
              `${guestIndex}-${dayIndex}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`
            );
            const unavailableRoomsForTimeslot = allocatedRoomsMap.get(
              `${guestIndex}-${dayIndex}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`
            );
            const staffId = ts?.staff?.find((s) => !unavailableStaffForTimeslot?.includes(s));
            const roomId = ts?.rooms?.find((r) => !unavailableRoomsForTimeslot?.includes(r));
            if (staffId && roomId) {
              allocatedStaffMap.set(
                `${guestIndex}-${dayIndex}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`,
                [...(unavailableStaffForTimeslot || []), staffId]
              );
              allocatedRoomsMap.set(
                `${guestIndex}-${dayIndex}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}`,
                [...(unavailableRoomsForTimeslot || []), roomId]
              );
              selectedTimeslotsWithStaffAndRoomAllocation.push(
                `${guestIndex}-${dayIndex}-${ts.optionGroupId}-${ts.optionId}-${ts.startTime}-${ts.endTime}-${staffId}-${roomId}`
              );
            }
          }
        });
      });
      return acc;
    },
    {
      allocatedStaffMap: new Map<string, string[]>(),
      allocatedRoomsMap: new Map<string, string[]>(),
      selectedTimeslotsWithStaffAndRoomAllocation: [],
    }
  );
  return selectedTimeslotsWithStaffAndRoomAllocation;
};
